import { render } from "./new-booking-modal.template.html?vue&type=template&id=4807460c&scoped=true"
import script from "./NewBookingModal.vue?vue&type=script&lang=ts"
export * from "./NewBookingModal.vue?vue&type=script&lang=ts"

import "./NewBookingModal.vue?vue&type=style&index=0&id=4807460c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4807460c"

export default script